import { useEffect } from "react";

import { enableSiteImproveTracking } from "./SiteImprove";

export function useSiteImprove(ready: boolean): void {
  useEffect(() => {
    if (ready) {
      enableSiteImproveTracking();
    }
  }, [ready]);
}
